module.exports = __webpack_public_path__ + "assets/img/doc_developer_ready.4d2d0d6a.png";